<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import DataTable from '@/components/tables/DataTable.vue';
import DataTableColumn from '@/components/tables/DataTableColumn.vue';
import type { LocaleSchema } from '@/locales/index.ts';
import type { Region } from '@/typings/regions/Region.ts';

const  { t } = useI18n<{ message: LocaleSchema }>({
  useScope: 'global',
});

defineProps<{
  regions: Region[];
}>();

const emit = defineEmits<{
  (e: 'row-action', region: Region): void;
}>();

const hoveredRegion = defineModel<Region>('hovered');

const handleRegionSelect = (region: Region) => {
  emit('row-action', region);
};

</script>

<template>
  <DataTable v-model:hovered="hoveredRegion"
             class="dataTable_regions"
             :items="regions"
             key-field="id"
             @row-click="handleRegionSelect">
    <DataTableColumn field="localizedName"
                     :label="t('browsingApp.regions.label')"
                     class="regionColumn">
      <template #default="{ item }">
        <div class="regionColumn-content">
          <span>{{ item.localizedName }}</span>
        </div>
      </template>
    </DataTableColumn>
    <!-- <DataTableColumn field="projectCount"
                     :label="t('browsingApp.regions.projectCount')"
                     class="projectCountColumn dataTable-numericColumn" /> -->
  </DataTable>
</template>

<style lang="scss">
.dataTable_regions {
  .regionColumn {
    width: 16ch;
    
    &-content {
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
    }
  }

  .projectCountColumn {
    width: 12ch;
  }
  
  .promotion-tag {
    display: inline-block;
    padding: 0.2rem 0.6rem;
    background-color: oklch(0.45 0.16 290);
    color: white;
    border-radius: 1rem;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.2;
    text-align: center;
    white-space: nowrap;
  }
}

@media screen and (max-width: 1400px)  {
  .dataTable_regions {
    .regionColumn {
      font-weight: 600;
    }
  }
}
</style>
